/**
 * Wistia Cover Loader
 *
 * Injects the Wistia player scripts for `wistia-player[data-defer-scripts]`
 * embeds (cover/background videos) after window load + a short settle, so the
 * player code and video stream stay out of the LCP-critical window. Until the
 * scripts land, the element is an inert tag over the hero poster image.
 */

const SETTLE_MS = 2500;

function injectPlayerScripts() {
  const players = document.querySelectorAll(
    'wistia-player[data-defer-scripts]',
  );
  if (!players.length) return;

  const add = (src, type) => {
    if (document.querySelector(`script[src="${src}"]`)) return;
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (type) s.type = type;
    document.head.appendChild(s);
  };

  add('https://fast.wistia.com/player.js');
  players.forEach((p) => {
    add(
      `https://fast.wistia.com/embed/${p.getAttribute('media-id')}.js`,
      'module',
    );
    watchForPlayback(p);
  });
}

// Fade the player in (see _components.hero.css) once its shadow video is playing.
// Polling because media events are non-composed and never cross the shadow boundary.
function watchForPlayback(player) {
  const tick = setInterval(() => {
    const video = player.shadowRoot?.querySelector('video');
    if (video && !video.paused) {
      player.classList.add('is-playing');
      clearInterval(tick);
    }
  }, 250);
  setTimeout(() => clearInterval(tick), 30000);
}

const start = () => setTimeout(injectPlayerScripts, SETTLE_MS);
if (document.readyState === 'complete') {
  start();
} else {
  window.addEventListener('load', start, { once: true });
}
